import { useContext, useEffect, useState } from 'react';
import { useInvestigationDetails } from '@hooks/useInvestigationDetails';
import { Stack, Typography } from '@mui/material';
import { LocalizationContext } from '@context/LocalizationContext';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';
import { useAnalytics } from '@hooks/useAnalytics';
import { RTextInput } from '../RTextInput/RTextInput';

interface IOpenQuestionProps {
	questionId: string;
	setCurrentAnswer: (answerId: any, answerText?: any) => void;
	isTextInputInvalid?: boolean;
	required?: boolean;
}

export default function OpenQuestion(props: IOpenQuestionProps) {
	const investigationDetails = useInvestigationDetails();
	const { AnswerTextInput } = useContext(LocalizationContext);
	const [answer, setAnswer] = useState<string>('');
	const { trackRefineEvent } = useAnalytics();

	// Reset the answer and loading state when the question changes
	useEffect(() => {
		setAnswer('');
	}, [props.questionId]);

	const handleAnswerChange = (value: string) => {
		props.setCurrentAnswer(props.questionId, value);
		setAnswer(value);
	};
	useEffect(() => {
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OPEN_QUESTION_OPENED);
	}, []);

	if (investigationDetails?.nextQuestion == null) return <></>;
	else
		return (
			<Stack
				width={'100%'}
				justifyContent={'center'}
				alignItems={'center'}
				maxWidth={'700px'}
				alignSelf={'center'}
				gap={'16px'}>
				<Typography
					variant={'questionText'}
					textAlign={'center'}
					data-cy={'pqOpenQuestionText'}
					tabIndex={0}
					aria-label={`The question is ${investigationDetails?.nextQuestion.questionText}`}>
					{investigationDetails?.nextQuestion.questionText}
				</Typography>

				<RTextInput
					autoFocus
					errorMessage={'Please add a description'}
					required={true}
					isValid={!props.isTextInputInvalid}
					data-cy={'pqOpenQuestionAnswerTextField'}
					multiline
					rows={4}
					value={answer}
					onChange={handleAnswerChange}
				/>

				{/*<TextField*/}
				{/*	data-cy={'pqOpenQuestionAnswerTextField'}*/}
				{/*	id="open-answer"*/}
				{/*	required*/}
				{/*	multiline*/}
				{/*	rows={4}*/}
				{/*	fullWidth*/}
				{/*	label={AnswerTextInput?.Label || 'Answer'}*/}
				{/*	value={answer}*/}
				{/*	variant="outlined"*/}
				{/*	onChange={handleAnswerChange}*/}
				{/*/>*/}
			</Stack>
		);
}
